import { render, staticRenderFns } from "./ParcelForum2026.vue?vue&type=template&id=3772c93e&"
import script from "./ParcelForum2026.vue?vue&type=script&lang=js&"
export * from "./ParcelForum2026.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports